/**
 * Runtime environment configuration.
 *
 * In Docker, VITE_* env vars aren't available at build time.
 * The container entrypoint generates /env-config.js which sets window.__ENV__.
 * This module reads from window.__ENV__ first (runtime), then falls back
 * to import.meta.env (build-time / local dev).
 */

interface RuntimeEnv {
  VITE_AZURE_CLIENT_ID?: string
  VITE_AZURE_TENANT_ID?: string
  VITE_AZURE_REDIRECT_URI?: string
  VITE_AZURE_API_SCOPE?: string
  VITE_DEV_BYPASS_AUTH?: string
  VITE_API_BASE_URL?: string
  VITE_API_URL?: string
  VITE_ENABLE_ADMIN?: string
}

declare global {
  interface Window {
    __ENV__?: RuntimeEnv
  }
}

const envAliases: Partial<Record<keyof RuntimeEnv, (keyof RuntimeEnv)[]>> = {
  VITE_API_BASE_URL: ['VITE_API_URL'],
}

export function getEnv(key: keyof RuntimeEnv): string {
  const keysToTry = [key, ...(envAliases[key] ?? [])]

  for (const envKey of keysToTry) {
    const runtimeValue = window.__ENV__?.[envKey]
    if (runtimeValue) return runtimeValue

    const buildTimeValue = import.meta.env[envKey] as string | undefined
    if (buildTimeValue) return buildTimeValue
  }

  return ''
}
